import { render, staticRenderFns } from "./MyServices.vue?vue&type=template&id=8af98598&scoped=true&"
import script from "./MyServices.vue?vue&type=script&lang=js&"
export * from "./MyServices.vue?vue&type=script&lang=js&"
import style0 from "./MyServices.vue?vue&type=style&index=0&id=8af98598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af98598",
  null
  
)

export default component.exports